import { createGlobalStyle } from "styled-components";

const styled = { createGlobalStyle };

const GlobalStyles = styled.createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: inherit;
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
  }

  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: transparent;
  }

  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  html {
    height: 100%;
    font-size: 62.5%; // 1rem = 10px, 10/16 = 60.25%
    box-sizing: border-box;
    background: var(--bg0, rgba(28, 28, 30, 1));

    @media screen and (max-width: 960px) {
      font-size: 56.25%; //1rem = 9px, 9/16 = 56.25%
    }

    @media screen and (max-width: 400px) {
      font-size: 50%; //1rem = 8px, 8/16 = 50%
    }
  }

  body {
    box-sizing: border-box;
  }
`;

export default GlobalStyles;

/* MEDIA QUERY MANAGER 
0 - 600px:  Phone
600 - 900px:  Tablet portrait
900 - 1200px:  Tablet landscape
[1200 - 1800] is where our normal styles apply
1800px+ :  Big desktop
*/
